import { useSeoMeta } from "@unhead/react";
import { Suspense } from "react";
import CyberscapeScene from "@/components/scenes/CyberscapeScene";
import { ProjectNavigation } from "@/components/site/ProjectNavigation";

const ProjectCyberscapePage = () => {
  useSeoMeta({
    title: "Let's Talk",
    description: "",
  });

  return (
    <div>
      <div className="relative h-screen">
        <Suspense fallback={null}>
          <CyberscapeScene />
        </Suspense>
      </div>
      <ProjectNavigation href="/portfolio/ethereal-threads" />
    </div>
  );
};

export default ProjectCyberscapePage;
